
import encrypt from '@/utils/crypto-util'
let aecdata: any
let md5: any
let md51: any
// 进行加密处理
// 获取随机数
let Randomnum: any
function getUuid() {
    return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        var r = (Math.random() * 16) | 0,
            v = c == 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
getUuid();
// 获取签名 
let hedata = () => {
    if (localStorage.getItem('usetoken')) {
        return { 'h_token': localStorage.getItem('usetoken') }
    }
}
hedata()
const fetchFUN = (type: any, data: any) => {
    return new Promise((resolve, reject) => {
        console.log(type, data, '上传数据');
        // 请求内容加密
        aecdata = encrypt.aesEncrypty({
            type: type,
            data: data
        })
        // 获取时间戳
        let time: any = Date.parse(new Date())
        Randomnum = getUuid()
        let data1 = `sign:data=${aecdata}&nonceStr=${Randomnum}&timestamp=${time}`
        // let data2 = `sign:data=&nonceStr=${Randomnum}&timestamp=${time}`
        // 获取MD5加密数据
        // md5 = encrypt.md5(config.data ? data1 : data2)
        // let newstr = JSON.stringify(aecdata)
        md51 = encrypt.md5(data1)
        let usertoken: any = localStorage.getItem('usetoken') ? localStorage.getItem('usetoken') : ''
        let xhr = new XMLHttpRequest()
        xhr.open('POST', 'https://gp.hnszxq.com/stats/erp')
        xhr.setRequestHeader('Content-Type', 'text/plain')
        xhr.setRequestHeader('h_timestamp', time)
        xhr.setRequestHeader('h_nonceStr', Randomnum)
        xhr.setRequestHeader('h_sign', md51)
        xhr.setRequestHeader('h_token', usertoken)
        xhr.onload = function (e) {
            if (this.status == 200 || this.status == 304) {
                let res = 'response' in xhr ? xhr.response : xhr.responseText
                resolve(JSON.parse(encrypt.aesDecrypt(res)))
            }
        };
        console.log('开始发送报错请求');
        //  setTimeout(()=>{
        xhr.send(aecdata)
        //  },5000)

    })
}
export default fetchFUN
